import { Proposition } from '../types';

export const VALUE_PROPOSITIONS = [
  Proposition.DigitalRetail,
  Proposition.PriceTrans,
  Proposition.CPO,
];
